import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

interface UseSelectedIndexProperties {
  indexKey: string;
}

const useSelectedIndex = ({ indexKey }: UseSelectedIndexProperties): number | null => {
  const [searchParameters] = useSearchParams();

  return useMemo(() => {
    const value = searchParameters.get(indexKey);

    if (value === null) {
      return null;
    }

    const parsed = Number(value);

    return Number.isNaN(parsed) || parsed < 0 ? null : parsed;
  }, [searchParameters, indexKey]);
};

export default useSelectedIndex;
